import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { ValueTypeConfirmDialogContent } from './ValueTypeConfirmDialogContent'

interface IProps {
  onAgree: () => void
  closeDialog: () => void
  show: boolean
}

export const ValueTypeConfirmDialog = ({ closeDialog, show, onAgree }: IProps) => {
  const contentProps = useMemo(
    () => ({
      onAgree,
      closeDialog,
    }),
    [onAgree, closeDialog]
  )

  return (
    <ModalDialog
      size={'xs'}
      content={ValueTypeConfirmDialogContent}
      contentProps={contentProps}
      show={show}
      onClose={closeDialog}
    />
  )
}
